const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  advancedSettings: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px',
    backgroundColor: '#F9FAFB',
    borderRadius: '8px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F3F4F6',
    },
  },
  header: {
    padding: '8px 0px',
  },
  badgeHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  badge: {
    display: 'flex',
    height: '20px',
    borderRadius: '5px',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '8px',
    marginTop: '3px',
    backgroundColor: '#015ffb14',
    padding: '0 8px',
    marginBottom: '4px',
  },
  advancedSettings_content: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& .MuiTypography-root': {
      fontSize: '14px',
      fontWeight: 500,
      color: '#111827',
      fontFamily: 'Inter',
    },
  },
  helperText: {
    fontSize: '12px',
    color: '#6B7280',
    marginTop: '4px',
    fontFamily: 'Inter',
  },
  scriptSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  bottomButton: {
    marginTop: '24px',
  },
})

export default styles
